import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/api/apiConfig";
import Header from "../common/Header";
import ResponseMessage from "../common/ResponseMessage";
import ConstanteFormBase from "../constante/ConstanteFormBase";
import { X } from "lucide-react";
import type { ConstanteFormData } from "../../types";

const ConstanteRegistration: React.FC = () => {
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: ConstanteFormData) => {
    setIsSubmitting(true);
    setResponseMessage("");

    // Transformation des données du formulaire en payload attendu par l'API
    const payload = {
      weight: data.poids ? parseFloat(data.poids) : null,
      height: data.taille ? parseFloat(data.taille) : null,
      bloodPressure: data.tensionArterielle || null,
      heartRate: data.frequenceCardiaque
        ? parseInt(data.frequenceCardiaque)
        : null,
      temperature: data.temperature ? parseFloat(data.temperature) : null,
      reason: data.motif || null,
      recordedAt: new Date().toISOString(),
      doctorId: data.doctorId ? parseInt(String(data.doctorId)) : null,
      patientId: data.maladeId ? parseInt(String(data.maladeId)) : null,
      medicalRecordId: data.dossierMedicalId || null,
    };

    try {
      await axiosInstance.post(API_ENDPOINTS.CONSTANTES.CREATE, payload);

      setResponseMessage("Constantes médicales enregistrées avec succès !");
      setTimeout(() => navigate("/admin/dashboard/constante"), 1500);
    } catch (err) {
      console.error(err);
      setResponseMessage("Erreur lors de l'envoi des constantes.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      <Header
        title="Enregistrer des Constantes Médicales"
        description="Ajoutez de nouvelles constantes médicales pour un patient."
        action={{
          label: "Retour",
          to: "/admin/dashboard/constante",
          icon: <X className="w-4 h-4" />,
        }}
        role="admin"
      />
      <section className="px-6">
        <ConstanteFormBase
          mode="create"
          role="admin"
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
        {responseMessage && (
          <ResponseMessage message={responseMessage} role="admin" />
        )}
      </section>
    </div>
  );
};

export default ConstanteRegistration;
